import { useTranslation } from 'react-i18next'
import { formatDate } from './cycleStatus'
import { humanizeCode } from './healthReportFormat'
import { markerValueText } from './supplementaryFormat'

const contextText = (t, context) => {
  if (!context) return null
  const parts = [
    context.classification && t(`cycleReports.classification.${context.classification}`, { defaultValue: humanizeCode(context.classification) }),
    ...(context.triggers ?? []).map((x) => x.trigger_detail || humanizeCode(x.rule_code)),
  ].filter(Boolean)
  return parts.length ? parts.join(' · ') : null
}

// VH-233: a marker measured in the cycle test and a supplementary test — the newest value
// (used for findings) next to the earlier value(s) with date, source and their context.
export function MarkerHistoryRows({ results = [] }) {
  const { t, i18n } = useTranslation()
  if (!results.length) return null
  const source = (s) => t(`healthCycle.supplementary.source.${s}`, { defaultValue: humanizeCode(s) })

  return (
    <div className="space-y-2" data-testid="marker-history-rows">
      <h4 className="text-xs font-semibold uppercase text-gray-600">{t('healthCycle.supplementary.valuesTitle')}</h4>
      <ul className="divide-y divide-gray-100 rounded-md border border-gray-200">
        {results.map((r) => (
          <li key={r.result_id} className="p-2 text-sm" data-testid={`marker-history-${r.marker_code ?? r.result_id}`}>
            <p className="font-medium text-gray-900">{r.marker_name}</p>
            <p className="text-gray-800">
              {t('healthCycle.supplementary.newest', {
                value: markerValueText(r, i18n.language), date: formatDate(r.measured_on, i18n.language), source: source(r.source),
              })}
            </p>
            {r.censored_over_numeric && <p className="text-xs text-amber-700">{t('healthCycle.supplementary.censoredOverNumeric')}</p>}
            {r.history.map((h) => {
              const context = contextText(t, h.context)
              return (
                <p key={h.result_id} className="text-xs text-gray-600">
                  {t('healthCycle.supplementary.earlier', {
                    value: markerValueText(h, i18n.language), date: formatDate(h.measured_on, i18n.language), source: source(h.source),
                  })}
                  {h.comparable === false && ` · ${t('healthCycle.supplementary.notComparable')}`}
                  {context && <span className="block text-amber-700">{context}</span>}
                </p>
              )
            })}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default MarkerHistoryRows
